import axios from "axios";
import { createContext, useState } from "react";
import { toast } from "react-toastify";

export const userContext = createContext();

export const UserContextProvider = (props) => {
  const backendUrl = process.env.REACT_APP_BACKEND_URL || "http://localhost:3000";
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(false);

  const getProfile = async () => {
    try {
      setLoading(true);
      const { data } = await axios.get(backendUrl + "/api/user/profile");
      if (data.success) {
        setProfile(data.profile);
        return data.profile;
      } else {
        toast.error(data.message);
      }
    } catch (error) {
      toast.error(error.message);
    } finally {
      setLoading(false);
    }
  };

  const updateProfile = async (profileData) => {
    try {
      setLoading(true);
      const { data } = await axios.put(backendUrl + "/api/user/profile", profileData);
      if (data.success) {
        setProfile(data.profile);
        toast.success("Profile updated successfully!");
        return { success: true, profile: data.profile };
      } else {
        toast.error(data.message);
        return { success: false, error: data.message };
      }
    } catch (error) {
      toast.error(error.response?.data?.message || "Failed to update profile");
      return { success: false, error: error.message };
    } finally {
      setLoading(false);
    }
  };

  const changePassword = async (passwordData) => {
    try {
      setLoading(true);
      const { data } = await axios.put(backendUrl + "/api/user/change-password", passwordData);
      if (data.success) {
        toast.success("Password changed successfully!");
        return { success: true };
      } else {
        toast.error(data.message);
        return { success: false, error: data.message };
      }
    } catch (error) {
      toast.error(error.response?.data?.message || "Failed to change password");
      return { success: false, error: error.message };
    } finally {
      setLoading(false);
    }
  };

  const uploadAvatar = async (file) => {
    try {
      setLoading(true);
      const formData = new FormData();
      formData.append('avatar', file);
      
      const { data } = await axios.post(backendUrl + "/api/user/avatar", formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      
      if (data.success) {
        setProfile(prev => ({ ...prev, avatar: data.avatar }));
        toast.success("Avatar uploaded successfully!");
        return { success: true, avatar: data.avatar };
      } else {
        toast.error(data.message);
        return { success: false, error: data.message };
      }
    } catch (error) {
      toast.error(error.response?.data?.message || "Failed to upload avatar");
      return { success: false, error: error.message };
    } finally {
      setLoading(false);
    }
  };

  const getUserStats = () => {
    if (!profile) return null;
    
    return {
      totalCourses: profile.stats?.totalCourses || 0,
      completedCourses: profile.stats?.completedCourses || 0,
      totalLessons: profile.stats?.totalLessons || 0,
      completedLessons: profile.stats?.completedLessons || 0,
      totalAssignments: profile.stats?.totalAssignments || 0,
      submittedAssignments: profile.stats?.submittedAssignments || 0,
      averageGrade: profile.stats?.averageGrade || 0,
      joinDate: profile.createdAt,
      lastActive: profile.lastActive,
    };
  };

  const value = {
    backendUrl,
    profile,
    setProfile,
    loading,
    getProfile,
    updateProfile,
    changePassword,
    uploadAvatar,
    getUserStats,
  };

  return (
    <userContext.Provider value={value}>
      {props.children}
    </userContext.Provider>
  );
};